import styled, { css } from 'styled-components/macro';
import { AlertProps } from './alert.types';
import { closeKeyframes, marqueeKeyframes } from './alert.animations';

export const AlertContainer = styled.div<{
  $mode: AlertProps['mode'];
  $isClosing: boolean;
}>`
  ${({ theme, $mode, $isClosing }) => css`
    box-sizing: border-box;
    padding-block: ${theme.spacings.componentOnly};
    padding-inline: ${theme.spacings.s};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    width: 100%;
    border-radius: ${theme.radiuses.xs};
    background-color: ${theme.semantic.indication[$mode].bg};
    border: 1px solid ${theme.semantic.indication[$mode].border};
    overflow: hidden;

    span {
      ${theme.fonts['body-14'].css};
    }

    ${$isClosing &&
    css`
      animation-name: ${closeKeyframes};
      animation-duration: ${theme.tokens.animation.duration.medium};
      animation-timing-function: ${theme.tokens.animation.easing.easeInOut};
      animation-fill-mode: forwards;
    `}
  `}
`;

export const TitleWrapper = styled.span`
  position: relative;
  overflow: hidden;
  flex: 1;
  white-space: nowrap;
  min-width: 0;
`;

export const MeasureSpan = styled.span`
  position: absolute;
  visibility: hidden;
  white-space: nowrap;
  pointer-events: none;
`;

export const TitleTrack = styled.span<{
  $isMarquee: boolean;
  $duration: string;
}>`
  ${({ $isMarquee, $duration }) =>
    $isMarquee
      ? css`
          display: inline-flex;
          width: max-content;
          animation: ${marqueeKeyframes} ${$duration} linear infinite;
        `
      : css`
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
        `}
`;

export const TitleText = styled.span<{ $isMarquee: boolean }>`
  ${({ $isMarquee }) =>
    $isMarquee &&
    css`
      padding-right: 3rem;
    `}
`;
